module.exports = function() {
  return new Worker(__webpack_public_path__ + "00245fa8e9553b49cff9.worker.js");
};